// extracted by mini-css-extract-plugin
module.exports = {"buttonBox":"share-action_buttonBox__idJiE","share_button":"share-action_share_button__XAs7k","ripple-fade":"share-action_ripple-fade__QLko0"};